// npm start -> "development" (test key) | npm run build -> "production" (live key)
const IS_PROD = process.env.NODE_ENV !== "production";

export const RAZORPAY_KEY_ID = IS_PROD
  ? "rzp_live_T9U2YhH0ND1XHg"
  : "rzp_test_SRTmdF0BA7f6o2";

/* =========================
   PARENT PLANS (Razorpay)
========================= */

// Test-mode variants only work with the test key; live-mode variants only work with the live key.
const freeVariantsTest = [{ id: "free", subscriptionId: "free", subscriptionUrl: "", label: "1", price: 0, maxStudents: 5 }];
const freeVariantsProd = [{ id: "free", subscriptionId: "free", subscriptionUrl: "", label: "1", price: 0, maxStudents: 5 }];

const foundationVariantsTest = [
  { id: "plan_SZ283EiSNb4iWq", subscriptionId: "sub_SZ2Q8gJSeDwDyy", subscriptionUrl: "https://rzp.io/rzp/XykU1mpN", label: "1", price: 29, maxStudents: 5 },
];
const foundationVariantsProd = [
  { id: "plan_T96H9Ky6MvZTJZ", subscriptionId: "sub_T96Ix3gEGjfk0t", subscriptionUrl: "https://rzp.io/rzp/kvEHwFY", label: "1", price: 29, maxStudents: 5 },
];

const coreVariantsTest = [
  { id: "plan_SZ2EA4sCaBbNZH", subscriptionId: "sub_SZ2SPmWmpzFyPQ", subscriptionUrl: "https://rzp.io/rzp/kWWLPmZ", label: "5", price: 99, maxStudents: 5 },
];
const coreVariantsProd = [
  { id: "plan_T96NTEtc2EyQYL", subscriptionId: "sub_T9UGBJhnbec1yJ", subscriptionUrl: "https://rzp.io/rzp/H2Hi6Lwc", label: "5", price: 99, maxStudents: 5 },
];

/*
export const plans = [
  {
    id: "free",
    title: "Basic",
    subtitle: "All essential school updates for your child",
    variants: IS_PROD ? freeVariantsProd : freeVariantsTest,
    type: "individual",
    cta: "Get Started",
    features: [
      "View Academic Updates",
      "School Announcements",
      "Student Profile Overview",
      "Homework Viewing & Submission",
      "Parent–Teacher Communication",
      "Exam Results",
      "Fee Records",
      "View basic transport updates",
    ],
  },
  {
    id: "foundation",
    title: "Homework Help",
    subtitle: "Quick help for daily homework and practice",
    tag: "Most Popular",
    accentGradient: "linear-gradient(135deg, #4F6EF7 0%, #7C3AED 100%)",
    variants: IS_PROD ? foundationVariantsProd : foundationVariantsTest,
    type: "individual",
    cta: "Try for ₹29",
    features: [
      "Includes all Basic features",
      "Instant Homework Help",
      "Step-by-step Solutions",
      "Homework Reminders",
      "Advanced Transport Tracking",
      "Up to 25 questions/month",
    ],
  },
  {
    id: "core",
    title: "Complete Learning",
    subtitle: "Help your child complete homework faster",
    tag: "Best Value",
    accentGradient: "linear-gradient(135deg, #10B981 0%, #0EA5E9 100%)",
    variants: IS_PROD ? coreVariantsProd : coreVariantsTest,
    type: "family",
    badge: "MOST_POPULAR",
    cta: "Start Now",
    features: [
      "Includes all Homework Help features",
      "Faster & more detailed solutions",
      "Practice & Revision Questions",
      "Track your child's progress",
      "Up to 100 Questions / month",
    ],
  },
];
*/
export const parentPlans = [
  {
    id: "basic",
    title: "Basic",
    subtitle: "Essential ERP foundation for schools starting their digital journey",
    variants: IS_PROD ? coreVariantsProd : coreVariantsTest,
    type: "school",
    cta: "Get Started",
    price: 99,
    features: [
      "Complete Administration & School Setup",
      "Student Registration & Management",
      "Admissions Management",
      "Fee Collection & Finance Management",
      "Daily Attendance Management",
      "Academic Management",
      "Examinations & Results",
      "Homework Creation & Study Materials",
      "Parent & Student Dashboards",
      "School Announcements",
      "Essential Reports & Analytics",
      "Push Notifications",
      "Role-Based Access & Security",
    ],
  },

  {
    id: "standard",
    title: "Standard",
    subtitle: "Everything you need for broader academic and operational management",
    tag: "Most Popular",
    accentGradient: "linear-gradient(135deg, #013A96 0%, #2563EB 55%, #4F46E5 100%)",
    variants: IS_PROD ? coreVariantsProd : coreVariantsTest,
    type: "school",
    badge: "MOST_POPULAR",
    cta: "Choose Standard",
    price: 199,
    features: [
      "Includes everything in Basic",
      "Advanced Student Management",
      "Online Admission Forms & Admission Pipeline",
      "Online Fee Payments & Fee Tracking",
      "Advanced Attendance Management",
      "Lesson Planning & Study Materials",
      "Complete Exam Scheduling & Report Cards",
      "Class & Teacher Timetables",
      "Assignments & Submission Tracking",
      "Parent Academic, Attendance & Homework Updates",
      "Circulars & Broadcast Communication",
      "Complete Transport Management",
      "Payroll & HR Management",
      "Advanced Reports & Management Dashboard",
      "Email & SMS Notifications",
    ],
  },

  {
    id: "premium",
    title: "Premium",
    subtitle: "The complete MySchoolling platform with premium AI capabilities",
    tag: "Complete Platform",
    accentGradient: "linear-gradient(135deg, #7C3AED 0%, #4F46E5 50%, #013A96 100%)",
    variants: IS_PROD ? coreVariantsProd : coreVariantsTest,
    type: "school",
    cta: "Choose Premium",
    price: 399,
    features: [
      "Includes every Basic & Standard feature",
      "Complete Student & Academic Management",
      "Advanced Academic Progress Tracking",
      "Online Assessments & Result Analytics",
      "Advanced Timetable & Conflict Management",
      "Teacher Feedback & Homework Notifications",
      "Advanced Parent & Student Engagement",
      "Individual & Teacher-Parent Communication",
      "Complete Transport Reports & Tracking",
      "RFID & Smart Attendance",
      "Complete Payroll Processing & Reports",
      "Advanced Management & Performance Analytics",
      "Advanced Notifications & Custom Alerts",
      "Enhanced Security & Activity Tracking",
      "AI Tutor",
      "Full Access to Every Current MySchoolling Module",
    ],
  },
];